import { FileNameSeparatorWithExtension } from '@/components/FileNameSeparatorWithExtension';
import styles from '@/components/InvoiceReportDetailDrawer/ApplicationContent/styles.module.scss';
import type {
  ActiveFileId,
  ProcessedBusinessDocument,
} from '@/components/InvoiceReportDetailDrawer/ApplicationContent/types';
import { ActiveFileType } from '@/components/InvoiceReportDetailDrawer/ApplicationContent/types';
import { Tag, TextLink } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames/bind';
import { FC, memo } from 'react';

const cx = classNames.bind(styles);

type BusinessDocumentsFieldViewProps = {
  processedDocuments: ProcessedBusinessDocument[];
  selectDocumentFile: (document: ProcessedBusinessDocument) => () => void;
  activeFile: ActiveFileId;
};

export const BusinessDocumentsFieldView: FC<BusinessDocumentsFieldViewProps> =
  memo(({ processedDocuments, selectDocumentFile, activeFile }) => {
    if (processedDocuments?.length === 0) {
      return null;
    }

    return (
      <>
        {processedDocuments?.map((processedDocument) => {
          const isActive =
            activeFile?.type === ActiveFileType.BUSINESS_DOCUMENT &&
            activeFile?.id === processedDocument?.id;

          return (
            <div
              className={cx(
                'linkContainer',
                isActive && 'active' // Add active state class
              )}
              key={
                processedDocument?.mf_file?.id ??
                'empty-view-business-documents-field'
              }
              onClick={selectDocumentFile(processedDocument)}
            >
              <Tag
                className={cx('tagContainer')}
                closable={false}
                status='default'
                icon={false}
                size='default'
              >
                {processedDocument?.label || ''}
              </Tag>
              <TextLink
                key={
                  processedDocument?.mf_file?.id ??
                  'empty-view-business-documents-field'
                }
                href={processedDocument?.href ?? ''}
                target='_blank'
                className={cx('textLinkContainer')}
                onClick={(e) => {
                  e.stopPropagation();
                  selectDocumentFile(processedDocument)();
                }}
              >
                <FileNameSeparatorWithExtension>
                  {processedDocument?.mf_file?.name ?? ''}
                </FileNameSeparatorWithExtension>
                <div className={cx('textLinkContainerExtension')}>
                  <span> {processedDocument?.document_number ?? ''}</span>
                </div>
              </TextLink>
            </div>
          );
        })}
      </>
    );
  });

BusinessDocumentsFieldView.displayName = 'BusinessDocumentsFieldView';
